import {FC, useEffect, useMemo} from 'react';
import useTimer from '@stencil/hotels-hooks/src/useTimer';
import * as S from './Countdowntimer.styles';

interface TimerProps {
  isDT?: boolean;
  timeInMs?: number;
  timerTextFromServer?: boolean;
  textColor?: string;
  setIsTimeExpired?: (isTimeExpired: boolean) => void;
  isSeo?: boolean;
  isShowSec?: boolean;
}
const Timer: FC<TimerProps> = props => {
  const {
    isDT,
    timeInMs,
    timerTextFromServer,
    textColor,
    setIsTimeExpired,
    isSeo,
    isShowSec = true,
  } = props;

  const {time, isTimeExpired} = useTimer(timeInMs);

  const {days, hours, minutes, seconds} = time;

  if (isTimeExpired && setIsTimeExpired) setIsTimeExpired(true);

  const timer = useMemo(() => {
    if (isSeo) return 'Expires at midnight';
    if (isTimeExpired) return 'Expired';
    if (days > 0) return `${timerTextFromServer ? '' : 'Ends in'} ${days}d ${hours}h`;
    return `${timerTextFromServer ? '' : 'Ends in'} ${hours}h: ${minutes}m${
      isShowSec ? `: ${seconds}s` : ''
    }`;
  }, [hours, isSeo, isTimeExpired, minutes, seconds, timerTextFromServer]);

  useEffect(() => {
    if ((isNaN(Number(timeInMs)) || Number(timeInMs) < 0) && setIsTimeExpired)
      setIsTimeExpired(true);
  }, [timeInMs, setIsTimeExpired]);

  return (
    <S.DealText isDT={isDT} textColor={textColor}>
      {timer}
    </S.DealText>
  );
};

export default Timer;
